
const data = [
    {
        title:"Squad Tech Lead",
        company:"RBC Digital",
        timeframe:"Dec 2019 - Current",
        responsibilities: [
            "Lead a squad of cross functional developers to deliver value to clients",
            "Work in an agile environment, delivering value in small frequent increments",
            "Actively involved in team’s talent recruitment and the student program"
        ]
    },
    {
        title:"Software Developer",
        company:"RBC Digital",
        timeframe:"Jul 2016 - Nov 2019",
        responsibilities: [
            "Worked in agile teams to develop client's profile and account center with Angular5 and Spring",
            "Developed RESTful services to be comsumed by RBC's mobile application",
            "Mentored students and new hires for the team"
        ]
    },
    {
        title:"Software Developer Intern",
        company:"RBC - Mobile and Online banking",
        timeframe:"Jul 2016 - Nov 2019",
        responsibilities: [
            "Worked on creation of RBCs mobile application with JQuery and Cordova",
            "Designed proof of concept mobile applications",
            "Represented RBC w Campus Recruitment team at conferences and hackathons"
        ]
    }
]

export default data;